import SupportContainer from "core/support/SupportContainer";

export default function Support() {
  return <SupportContainer />;
}
